// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"465":"ef48ef26","840":"7d523886"}[chunkId] + ".chunk.css";
};